import { Toggle as FluentToggle, IToggleProps } from "@fluentui/react";
import React from "react";

export interface ISwitchProps extends IToggleProps {
    testId?: string;
}

export const Switch: React.FunctionComponent<ISwitchProps> = (props: ISwitchProps) => {
    return <FluentToggle {...props} styles={props.styles} />;
};
